export interface BulkPriceSchemeItem {
    schemeId: string
    /** "AMBAR" ya da "YURTICI". Ekranda gösterilmez, detay çağrısında gider. */
    moduleKey: string
    moduleName: string
    refNo?: string
    name?: string
    description?: string
    /** "Gelir" ya da "Gider". */
    agreementTypeName?: string
    /** "Komple" ya da "Baremli". */
    agreementKindName?: string
    /** Seçili hizmet kalemi; yoksa "Dinamik Hizmet Kalemi". */
    serviceItemName?: string
    isCustomActive: boolean
    isCustomActiveName?: string
    isSelected: boolean
}

export interface GetBulkPriceSchemeListResponseData {
    items: BulkPriceSchemeItem[]
    totalRecordCount: number
}

export interface GetBulkPriceSchemeListResponse {
    isSuccess: boolean
    message: any
    data: GetBulkPriceSchemeListResponseData
}

export const initialGetBulkPriceSchemeListResponseData: GetBulkPriceSchemeListResponseData = {
    items: [],
    totalRecordCount: 0
}

export interface BulkPriceAgreementCriteria {
    name?: string
    value?: string
}

export interface BulkPriceAgreementItem {
    agreementId: string
    moduleKey: string
    schemeId: string
    schemeRefNo?: string
    schemeName?: string
    refNo?: string
    startDate?: string
    startDateStr?: string
    endDate?: string
    endDateStr?: string
    minPrice?: number
    unitPrice?: number
    /** Şablondan gelen kriterler; tablo bunlara göre kurulur. */
    criteria: BulkPriceAgreementCriteria[]
    isSelected: boolean
}

export interface GetBulkPriceAgreementListResponseData {
    /** Şablondan gelen kriter kolonları (seçilen şablonların birleşimi). */
    columns: string[]
    items: BulkPriceAgreementItem[]
    totalRecordCount: number
}

export interface GetBulkPriceAgreementListResponse {
    isSuccess: boolean
    message: any
    data: GetBulkPriceAgreementListResponseData
}

export const initialGetBulkPriceAgreementListResponseData: GetBulkPriceAgreementListResponseData = {
    columns: [],
    items: [],
    totalRecordCount: 0
}

/** Kalem bazlı giriş gridi: en son Eskalasyon Dağılımı ağırlıkları. */
export interface EscalationCostItemWeight {
    costItemId: string
    name?: string
    /** Eskalasyon Dağılımındaki ağırlık (%). Bu ekranda değiştirilemez. */
    weight?: number
    /** Kullanıcının girdiği artış oranı (%) — yalnız ekranda tutulur. */
    rate?: string
    /** Kullanıcının girdiği tutar — yalnız ekranda tutulur. */
    amount?: string
}

export interface GetEscalationCostItemWeightsResponse {
    isSuccess: boolean
    message: any
    data: {
        items: EscalationCostItemWeight[]
        /** Ağırlıkların alındığı dağılım kaydı. */
        sourceInfo?: string
    }
}

export interface ApplyEscalationResponse {
    isSuccess: boolean
    message: any
    data: {
        priceEscalationId: string
        jobQueueId?: string
        agreementCount: number
        effectiveRate?: number
    }
}

export interface PriceEscalationHistoryCostItem {
    name?: string
    weight?: number
    rate?: number
    amount?: number
    effectRate?: number
}

export interface PriceEscalationHistoryAgreement {
    sourceRefNo?: string
    newRefNo?: string
    unitPriceBefore?: number
    unitPriceAfter?: number
    minPriceBefore?: number
    minPriceAfter?: number
    increaseRate?: number
    increaseAmount?: number
    isSkipped: boolean
    skipReason?: string
}

export interface PriceEscalationHistoryItem {
    priceEscalationId: string
    processDate?: string
    userName?: string
    startDateStr?: string
    endDateStr?: string
    allCostItems: boolean
    ruleText?: string
    appliedCount: number
    skippedCount: number
    effectiveRate?: number
    totalIncreaseAmount?: number
    costItems: PriceEscalationHistoryCostItem[]
    agreements: PriceEscalationHistoryAgreement[]
}

export interface GetPriceEscalationHistoryResponse {
    isSuccess: boolean
    message: any
    data: {
        items: PriceEscalationHistoryItem[]
        totalRecordCount: number
    }
}

export interface ExportBulkPriceResponse {
    isSuccess: boolean
    message: any
    data: string
}
